import * as React from 'react';
import { SVGProps } from 'react';
const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" {...props}>
    <path
      d="M7.203.25A6.75 6.75 0 1 0 13.953 7 6.758 6.758 0 0 0 7.203.25Zm0 12a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Zm-.75-5V4a.75.75 0 0 1 1.5 0v3.25a.75.75 0 0 1-1.5 0Zm1.75 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      fill="currentColor"
    />
  </svg>
);
export default InfoIcon;
